import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { connect } from 'react-redux';

import withi18n from '~/utils/withI18n';

import IconWithBG from '~/components/IconWithBG';
import { getLabelWithDefaultStr } from '~/utils/i18n';

type Props = {
  rechargeProcut: Object,
  i18n: Object,
  locale: String,
};

const mapStateToProps = ({ rechargeProcut }) => ({ rechargeProcut });

export default
@withi18n
@connect(mapStateToProps, {})
class Introduce extends React.Component<Props> {
  translate = (key, defaultVal) =>
    getLabelWithDefaultStr(`exchange-recharge-${key}`, this.props.i18n, defaultVal);

  render() {
    const { props } = this;
    const { rechargeProcut } = props;
    let { mediaInfo, info, name, fullName, image } = rechargeProcut;
    mediaInfo = JSON.parse(mediaInfo || '{}');
    info = JSON.parse(info || '{}');

    return (
      <Wrapper>
        <GlobalStyle />
        <div className="content">
          <div className="currencyBox">
            <IconWithBG width={30} src={image} />
            <span className="code">{name}</span>
            <span className="name">{fullName}</span>
          </div>
          <div className="desc">{info[props.locale] || info.en}</div>
          <div className="learnBox">
            <a className="linkText" href={mediaInfo.research} target={props.getTarget()}>
              {`${this.translate('lernMore')} >`}
            </a>
            <div className="iconBox">
              {['twitter', 'web', 'facebook', 'tg', 'blog'].map(item => {
                let icon = item;
                if (item === 'tg') icon = 'telegram';
                if (item === 'blog') icon = 'blog1';

                return (
                  mediaInfo[item] && (
                    <a target={props.getTarget()} href={mediaInfo[item]} key={item}>
                      <IconWithBG
                        type={icon}
                        width={26}
                        color="#FFF"
                        bgColorHoverd="#F0B90B"
                        size={14}
                        bgColor="#D8D8D8"
                        margin="0 0 0 10px"
                      />
                    </a>
                  )
                );
              })}
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

const GlobalStyle = createGlobalStyle`
  .bnc-tooltip-inner {
    border-radius: 4px;
  }
`;

const Wrapper = styled.div`
  padding: 0 16px;
  margin: 24px auto 32px;
  width: 100%;
  > .content {
    border: 1px solid #eaecef;
    border-radius: 3px;
    padding: 32px 16px 24px;
    > .currencyBox {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      > .code {
        font-weight: 500;
        font-size: 24px;
        margin: 0 8px;
      }
      > .name {
        color: #848e9c;
        font-size: 20px;
      }
    }
    > .desc {
      color: #848e9c;
      font-size: 16px;
      line-height: 28px;
    }
    > .learnBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      > .linkText {
        color: #f0b90b;
        font-size: 16px;
        margin-top: 16px;
      }
      > .iconBox {
        margin-top: 16px;
        margin-left: -10px;
        > a {
          display: inline-block;
        }
      }
    }
  }
  @media (min-width: 768px) {
    > .content {
      padding: 32px 24px;
    }
  }
  @media (min-width: 1260px) {
    width: 1260px;
    padding: 0px;
    margin: 24px auto 56px;
    > .content {
      padding: 32px;
    }
  }
`;
